<template>
  <div data-testid="patient-weight-container">
    <label>Patient Weight</label>
    <md-field>
      <md-input
        v-integer-only
        type="number"
        :aria-label="`Patient Weight ${unit}`"
        data-testid="patient-weight"
        :value="convertedWeight"
        :min="0"
        :disabled="readonly"
        @input="(weight) => updateWeight(weight)"
      />
      <span class="unit" data-testid="patient-weight-unit">
        {{ unit }}.
      </span>
    </md-field>
  </div>
</template>

<script>
export default {
  name: 'patient-weight-input',
  props: {
    caseConf: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    convertedWeight() {
      const { weight } = this.caseConf.initialConditions;
      if (weight === null || weight === undefined) {
        return null;
      }
      return Math.round(weight * this.conversionMultiplier);
    },
    conversionMultiplier() {
      const { measurementSystem } = this.caseConf;
      if (measurementSystem === 'IMPERIAL') {
        // kg to pound
        return 2.20462;
      }
      return 1;
    },
    unit() {
      const { measurementSystem } = this.caseConf;
      if (measurementSystem === 'IMPERIAL') {
        return 'lbs';
      }
      return 'kgs';
    },
  },
  methods: {
    updateWeight(weight) {
      this.$emit('update', {
        initialConditions: {
          weight: weight / this.conversionMultiplier,
        },
      });
    },
  },
};
</script>

<style scoped>
.md-field input {
  width: 52px;
  padding: 0 !important;
  padding-left: 10px !important;
  text-align: center;
}

.unit {
  color: #2b2b2b;
  font-size: 16px;
  line-height: 20px;
  margin-left: 8px;
}
</style>